/**
 * silverPriceService.js
 * Silver has no live feed — rates are set manually by an admin
 * (System → Silver Rates) and stored server-side in SystemConfig.
 * Response shape mirrors goldPriceService: { rates: [{karat, purity, perGram, per10gram}], date }.
 */

import API from './api';

let _cache = null; // { data, fetchedAt }
const CACHE_TTL_MS = 5 * 60 * 1000;

export async function fetchSilverRates(force = false) {
  if (!force && _cache && Date.now() - _cache.fetchedAt < CACHE_TTL_MS) {
    return _cache.data;
  }
  try {
    const res = await API.get('/system/silver-rates');
    const data = {
      rates: Array.isArray(res.data?.rates) ? res.data.rates : [],
      date: res.data?.date || null,
      notConfigured: Boolean(res.data?.notConfigured),
    };
    _cache = { data, fetchedAt: Date.now() };
    return data;
  } catch (err) {
    console.warn('[silverPriceService] Failed to fetch silver rates:', err.message);
    return null;
  }
}

export async function updateSilverRates(rates) {
  const res = await API.put('/system/silver-rates', { rates });
  _cache = null;
  return res.data;
}

export function invalidateSilverRateCache() {
  _cache = null;
}
